import { Trophy } from 'lucide-react';
import { DIFFICULTY_CONFIG } from '../config/gameConfig';

/**
 * HighScoresDisplay Component
 * Shows the top 10 high scores
 */
export default function HighScoresDisplay({ highScores, currentScore = null }) {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffDays = Math.floor((now - date) / (1000 * 60 * 60 * 24));

    if (diffDays === 0) return 'I dag';
    if (diffDays === 1) return 'I går';
    if (diffDays < 7) return `${diffDays} dage siden`;
    return date.toLocaleDateString('da-DK', { day: 'numeric', month: 'short' });
  };

  const getDifficultyLabel = (difficulty) => {
    return DIFFICULTY_CONFIG[difficulty]?.label || difficulty;
  };

  if (highScores.length === 0) {
    return (
      <div className="text-center p-8 bg-gray-50 rounded-2xl">
        <Trophy className="mx-auto text-gray-400 mb-4" size={48} />
        <p className="text-gray-600 text-lg">
          Ingen højeste scores endnu.
        </p>
        <p className="text-gray-500 mt-2">
          Vær den første til at sætte en rekord!
        </p>
      </div>
    );
  }

  return (
    <div className="bg-gradient-to-br from-yellow-50 to-orange-50 rounded-2xl p-6">
      <div className="flex items-center justify-center mb-6">
        <Trophy className="text-yellow-500 mr-2" size={32} />
        <h3 className="text-2xl font-bold text-gray-800">Top 10 Scores</h3>
      </div>

      <div className="space-y-2">
        {highScores.map((entry, index) => {
          const isCurrentScore = currentScore && entry.score === currentScore && entry.playerName === currentScore.playerName;
          const medalEmoji = index === 0 ? '🥇' : index === 1 ? '🥈' : index === 2 ? '🥉' : null;

          return (
            <div
              key={`${entry.date}-${index}`}
              className={`flex items-center justify-between p-3 rounded-xl transition-all ${
                isCurrentScore
                  ? 'bg-green-200 border-2 border-green-500 scale-105'
                  : 'bg-white hover:bg-gray-50'
              }`}
            >
              <div className="flex items-center space-x-3 flex-1">
                <span className="text-xl font-bold text-gray-500 w-8">
                  {medalEmoji || `${index + 1}.`}
                </span>
                <div className="flex-1">
                  <div className="font-bold text-gray-800">{entry.playerName}</div>
                  <div className="text-sm text-gray-600">
                    {getDifficultyLabel(entry.difficulty)} • {formatDate(entry.date)}
                  </div>
                </div>
              </div>
              <div className="text-right">
                <div className="text-2xl font-bold text-purple-600">
                  {entry.score.toLocaleString()}
                </div>
                {entry.level > 1 && (
                  <div className="text-sm text-gray-600">
                    Niveau {entry.level}
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
